import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'underscore';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { ButtonDropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import React, { Component } from 'react';
import { getIsPermittedWithAnyOfThesePermissions } from '../common/classes/permissions';
import ReportsActionHandler from './reportsActionHandler';
import ReportActionModal from './reportActionModal';
import entityComposition from '../common/classes/entityComposition';
import reportFunctions from './reportFunctions';
import Icon from '../common/containers/icon';
import AssignmentModal from '../issues/assignmentModal';
const baseActions = [{
  text: 'Submit',
  icon: 'inbox'
}, {
  text: 'Assign',
  icon: 'user-plus'
}, {
  text: 'Approve',
  icon: 'check'
}, {
  text: 'Process',
  icon: 'check'
}, {
  text: 'Reject',
  icon: 'times'
}, {
  text: 'Delete',
  icon: 'trash'
}];
const undeleteAction = {
  text: 'Restore',
  icon: 'undo'
};
class ReportsBulkActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      assignmentModalIsOpen: false,
      currentAction: null,
      pendingApprove: false,
      userCanEditIssues: getIsPermittedWithAnyOfThesePermissions(['issue_admin', 'issue_reviewer'])
    };
    this.getSelected = this.getSelected.bind(this);
    this.getIssuesToApprove = this.getIssuesToApprove.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleButtonSelect = this.handleButtonSelect.bind(this);
    this.handleModalAction = this.handleModalAction.bind(this);
    this.openAssignmentModal = this.openAssignmentModal.bind(this);
    this.closeAssignmentModal = this.closeAssignmentModal.bind(this);
    this.handleAssignmentSave = this.handleAssignmentSave.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  /* eslint-disable react/sort-comp, camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const pendingApprove = this.state.pendingApprove;
    /* eslint-enable react/sort-comp, camelcase */
    // set state to pendingApprove && currentAction
    if (pendingApprove && nextProps.report.selections.length > 0) {
      this.setState({
        pendingApprove: false,
        currentAction: 'Approve'
      });
    }
  }
  getSelected() {
    const _this$props$report = this.props.report,
      list = _this$props$report.list,
      selected = _this$props$report.selected;
    return list.filter(_ref => {
      let id = _ref.id;
      return _.contains(selected, id);
    });
  }

  /**
   * @method getIssueToApprove
   * if the selected reports have issues, return all without a status of
   * 'reviewed' or 'closed'
   */
  getIssuesToApprove() {
    // An issue does not need approval if it has a status of reviewed or closed
    const statusIsApproved = ['reviewed', 'closed'];
    const needsApproval = issue => {
      const content = JSON.parse(issue.content);
      if (!content.status) {
        return true;
      }
      const _Object$keys = Object.keys(content.status),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        statusIdentifier = _Object$keys2[0];
      return !statusIsApproved.includes(statusIdentifier);
    };
    const selections = this.props.report.selections;
    const issues = [];
    if (selections && selections.length) {
      selections.forEach(detailedReport => issues.push(...(detailedReport.issues || []).filter(needsApproval)));
    }
    return issues;
  }
  async openAssignmentModal() {
    const _this$props = this.props,
      _this$props$report2 = _this$props.report,
      selected = _this$props$report2.selected,
      list = _this$props$report2.list,
      reportAssignmentModalAssign = _this$props.reportAssignmentModalAssign,
      reportAssignmentModalAssignActions = _this$props.reportAssignmentModalAssignActions,
      serverFilter = _this$props.employeeModalAssignActions.serverFilter,
      employeeModalAssignIndexQuery = _this$props.employeeModalAssignIndexQuery;
    const selectedJobs = list.filter(listReport => selected.some(id => id === listReport.id)).map(detail => ({
      id: detail.jobID
    }));
    await reportAssignmentModalAssignActions.serverFilter({
      report: selected.map(id => ({
        id
      }))
    }, reportAssignmentModalAssign.indexQuery, false);
    await serverFilter({
      job: selectedJobs,
      assignmentJobs: selectedJobs,
      status: 1
    }, employeeModalAssignIndexQuery, false);
    this.setState({
      assignmentModalIsOpen: true
    });
  }
  handleButtonSelect(currentAction) {
    const _this$props2 = this.props,
      reportActions = _this$props2.reportActions,
      report = _this$props2.report,
      issueActions = _this$props2.issueActions,
      issueIndexQuery = _this$props2.issueIndexQuery,
      issueStatusActions = _this$props2.issueStatusActions,
      issueStatusIndexQuery = _this$props2.issueStatusIndexQuery;
    const userCanEditIssues = this.state.userCanEditIssues;
    const state = {};
    if (currentAction === 'Approve' && userCanEditIssues) {
      // trigger lookup actions and set set state.currentAction to Approve
      // in UNSAFE_componentWillReceiveProps
      reportActions.serverIndexDetail(report.selected);
      issueActions.serverIndex(issueIndexQuery);
      issueStatusActions.serverIndex(issueStatusIndexQuery);

      // tracking lookup actions in progress
      state.pendingApprove = true;
    } else if (currentAction === 'Assign') {
      // Open the modal
      this.openAssignmentModal();
    } else if (currentAction === 'Restore') {
      // Handle restore action
      reportActions.serverUndeleteReports(report.selected);
    } else {
      state.currentAction = currentAction;
    }
    this.setState(state);
  }
  handleHide() {
    this.setState({
      currentAction: null
    });
  }
  handleModalAction(action) {
    let info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const _this$props3 = this.props,
      reportActions = _this$props3.reportActions,
      geolocation = _this$props3.geolocation;
    this.setState({
      currentAction: null
    }, () => {
      reportActions.serverSaveStatusUpdates(this.getSelected(), action, info, geolocation);
    });
  }
  closeAssignmentModal() {
    this.setState({
      assignmentModalIsOpen: false
    });
  }
  handleAssignmentSave(employeeAssignments, removals) {
    const _this$props4 = this.props,
      selected = _this$props4.report.selected,
      serverSaveAssignments = _this$props4.reportActions.serverSaveAssignments;
    const removalAssignments = removals.map(userID => ({
      userID,
      remove: true
    }));
    const additiveAssignments = employeeAssignments.map(userID => ({
      userID,
      remove: false
    }));
    const allUpdates = removalAssignments.concat(additiveAssignments);
    const assignments = [];
    selected.forEach(reportID => {
      allUpdates.forEach(update => {
        assignments.push(_objectSpread(_objectSpread({}, update), {}, {
          reportID
        }));
      });
    });
    serverSaveAssignments(uuid(), assignments);
    this.setState({
      assignmentModalIsOpen: false
    });
  }
  toggle() {
    const open = this.state.open;
    this.setState({
      open: !open
    });
  }
  render() {
    const _this$state = this.state,
      open = _this$state.open,
      currentAction = _this$state.currentAction,
      assignmentModalIsOpen = _this$state.assignmentModalIsOpen;
    const _this$props5 = this.props,
      selected = _this$props5.report.selected,
      user = _this$props5.user,
      reportAssigments = _this$props5.reportAssignmentModalAssign.list,
      metaDeleted = _this$props5.metaDeleted,
      username = _this$props5.username;

    // Show restore option only to admin users - change to `true` to enable for all users
    const isAdminUser = username === 'truqc';

    // Build actions list and filter based on metaDeleted state
    let actions = [...baseActions];
    if (isAdminUser) {
      actions.push(undeleteAction);
    }

    // Filter actions based on metaDeleted state
    actions = actions.filter(action => {
      if (action.text === 'Delete') {
        return metaDeleted !== 1; // Show Delete only when not viewing deleted reports
      }
      if (action.text === 'Restore') {
        return metaDeleted === 1; // Show Restore only when viewing deleted reports
      }
      return true;
    });
    const issues = this.getIssuesToApprove();
    return /*#__PURE__*/React.createElement(ButtonDropdown, {
      isOpen: open,
      toggle: this.toggle,
      id: "reportBulkActions",
      size: "sm"
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      disabled: selected.length === 0,
      caret: true
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      glyph: "bolt"
    }), " Actions")), /*#__PURE__*/React.createElement(DropdownMenu, null, actions.map(action => /*#__PURE__*/React.createElement(DropdownItem, {
      key: action.text,
      ref: action.text,
      className: "t-rba-button-".concat(kebabCase(action.text)),
      disabled: reportFunctions.isActionDisabled(user, action.text.toLowerCase(), this.getSelected()),
      onClick: () => this.handleButtonSelect(action.text)
    }, /*#__PURE__*/React.createElement(Icon, {
      style: {
        width: '10%',
        marginRight: '5px'
      },
      glyph: action.icon
    }), " ", action.text))), /*#__PURE__*/React.createElement(AssignmentModal, {
      assignments: reportAssigments,
      isOpen: assignmentModalIsOpen,
      closeModal: this.closeAssignmentModal,
      saveAssignments: this.handleAssignmentSave,
      selected: selected
    }), /*#__PURE__*/React.createElement(ReportsActionHandler
    // need another state to indicate waiting
    , {
      currentAction: currentAction,
      issues: issues,
      onCancel: this.handleHide
    }, /*#__PURE__*/React.createElement(ReportActionModal, {
      actionText: currentAction,
      onHide: this.handleHide,
      onAction: this.handleModalAction
    })));
  }
}
ReportsBulkActions.propTypes = {
  employeeModalAssignIndexQuery: PropTypes.shape({}).isRequired,
  reportAssignmentModalAssign: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  reportAssignmentModalAssignActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  employeeModalAssignActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  issueIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  issueActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  issueStatusIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  issueStatusActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  report: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    selected: PropTypes.arrayOf(PropTypes.string),
    selections: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  reportActions: PropTypes.shape({
    serverSaveStatusUpdates: PropTypes.func,
    serverIndexDetail: PropTypes.func,
    serverSaveAssignments: PropTypes.func,
    serverUndeleteReports: PropTypes.func
  }).isRequired,
  geolocation: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.shape({}),
    user_id: PropTypes.string
  }).isRequired,
  metaDeleted: PropTypes.number,
  username: PropTypes.string
};
ReportsBulkActions.defaultProps = {
  metaDeleted: 0,
  username: ''
};
export { ReportsBulkActions as TestReportsBulkActions };
export default entityComposition(ReportsBulkActions, ['report', 'reportAssignmentModalAssign'], {
  issueIndexQuery: state => state.issue.indexQuery,
  issueStatusIndexQuery: state => state.issueStatus.indexQuery,
  geolocation: state => state.login.geolocation,
  user: state => state.login.user,
  employeeModalAssignIndexQuery: state => state.employeeModalAssign.indexQuery
}, ['issue', 'issueStatus', 'employeeModalAssign']);